import { ILayerFactory } from "../layerFactory/ILayerFactory";

/**
 * ズームレベル制限エラークラス
 */
export class ZoomLevelError {
  /**
   * 表示中レイヤ
   */
  constructor(private _visibleLayers: ILayerFactory[]) {}
  /**
   * 表示中レイヤ名リストを取得
   */
  getVisibleLayersName(): string[] {
    return this._visibleLayers.map((e) => e.constructor.name);
  }
}
